import { contactApi } from '../api';
import { IContactInfo } from '../model/contact.model';
import { ACTION_TYPES } from './store/actions';

export const createContact = (contact: IContactInfo) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.CREAT_CONTACT_FORM,
    payload: contactApi.createContact(contact),
  });
};

export const createRescindContact = (contact: IContactInfo) => async dispatch => {
  await dispatch({
    payload: contactApi.createContact(contact),
  });
};

export const toClientIpContactModel = (contact: IContactInfo) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.CREAT_CONTACT_FORM,
    payload: contactApi.toClientIpContactModel(contact),
  });
};

export const resetContact = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.RESET,
    payload: null,
  });
};
